import { useRoute, useHead, useSeoMeta } from 'nuxt/app';
import { BASE_SITE } from '~~/constants';

export const usePageSeo = (_options?: { ogType?: string }) => {
  const route = useRoute();

  const canonicalPath = route.path;
  const canonicalUrl = `${BASE_SITE.URL}${canonicalPath}`;

  useHead(() => ({
    link: [
      {
        hid: 'canonical',
        rel: 'canonical',
        href: canonicalUrl,
      },
    ],
  }));

  useSeoMeta({
    ogUrl: canonicalUrl,
    ogSiteName: BASE_SITE.TITLE,
    ogLocale: 'es_CL',
    twitterCard: 'summary_large_image',
    ogImage: BASE_SITE.IMAGE,
    twitterImage: BASE_SITE.IMAGE,
  });
};
